import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentLoading from './AsyncComponentLoading';
import AsyncComponentError from './AsyncComponentError';
const AsyncVerifyScriptPromptCheck = Loadable({
  loader: () => import( /* webpackChunkName: "verify-install-prompt" */'../../verify-install/components/VerifyScriptPromptCheck'),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentError
});
export default AsyncVerifyScriptPromptCheck;